
var zh_cn = {
  pushTip: {
    pushType0: "今回のプッシュでは、‘nums’台のデバイスが完了しました。これらのデバイスをスキップしますか",
    pushSuccess: "タスクの詳細にジャンプして、スケジュールを確認しますか",
    push_all_by_mem: "ルート業者をプッシュしますか: {mem}すべての設備",
    push_all: "すべてのルート業者におけるすべての設備をプッシュしますか？",
  },
  app_pushAll: 'すべてのデバイスを転送',
  app_uploadApp: 'アップロードアプリケーション',
  app_No: '番号付け',
  app_terNo: 'ターミナル番号',
  app_name: '名前',
  app_appName: '名前を適用',
  app_appType: 'タイプを適用',
  app_insType: 'インストールの種類',
  app_vStatus: '状態を確認する',
  app_ulTime: 'アップロード時間',
  app_verror: 'バージョン異常',
  app_tipterop: 'ターミナル操作を促す',
  app_autocmpl: '自動完了',
  app_appLoding: 'アプリケーションはアップロード中です',
  app_newgVer: '最新バージョン番号',
  app_fmVerIillegal: 'バージョン番号は合法的ではなく、数字でなければなりません。1.00などです',
  app_fmVerIillegal1: 'バージョン番号は合法的ではなく、vと数字を持っていなければなりません',
  app_operate: '操作',
  app_type: 'タイプ',
  app_del: '削除',
  app_pause: '一時停止',
  app_continue: '続行',
  app_status: '状態',
  app_new: '追加',
  app_yes: 'はい、',
  app_no: 'いいえ、',
  app_selectAll: 'すべて選択',
  app_save: '保存',
  app_process: '進捗',
  app_push: 'プッシュを確認する',
  app_terminal: 'ターミナル',
  app_to: 'はい、',
  app_offShelf: '棚をおりる',
  app_mulOffShelf: 'ロット下フレーム',
  app_isOffShelf: '適用しますか',
  app_isDelApp: '適用しますか',
  app_chooseOneMust: '少なくとも一つのアプリケーションを選択します。',
  app_cantDelTask: '削除できないジョブが含まれているかどうかを選択します。',
  app_oneRecordMust: '少なくとも一つのレコードを選択します。',
  app_phoneIllegal: '携帯の番号は合法的ではないです。',
  app_groupName: '分类名称',
  app_sure: '確認',
  app_query: 'クエリー',
  app_reset: 'リセット',
  app_cancel: 'キャンセル',
  app_edit: '編集',
  app_add: '追加',
  app_verify: '審査する',
  app_isPass: '通過するかどうか',
  app_pass: '通過する',
  app_ban: 'パスしない',
  app_noInput: '未記入',
  app_banReason: '理由を拒む',
  app_filter: 'フィルタ',
  app_prePushVerify: '審問を待つ',
  app_preVerify: '審査待ち',
  app_verifyPass: '通過する',
  app_verifyNotPass: 'パスしない',
  app_success: '成功',
  app_submit: '送信',
  app_other: 'その他',
  app_tip: 'ヒント',
  app_online: 'オンライン',
  app_offline: 'オフライン',
  app_fileOver: 'ファイル',
  app_onlyApk: 'apkファイルしかアップロードできません',
  app_tipViewTask: 'プッシュ成功，タスク管理中に推送の進捗を見てください',
  app_tipMkDel: 'アプリケーションが削除されると,アプリケーション市場のアプリケーションも同時に削除され,削除が確定しますか',
  app_tipAppEdit: '削除は復帰不可能となり,削除が確定しますか',
  app_tipVerify: '審査に出すのを確定しますか',
  app_rqsError: '要求エラー',
  app_mulAdd: '一括追加',
  app_select: '選択してください',
  app_input: '内容を入力してください',
  app_inputCp: '記入してください',
  app_inputName: '名前を入力してください',
  app_inputContact: '連絡先を入力してください',
  app_inputTruePhone: '正しい番号を入力してください。',
  app_inputAddr: '住所を入力してください',
  app_inputVer: 'バージョンを入力してください',
  app_inputVerTag: 'バージョンの識別情報を入力してください。',
  app_inputID: 'ファイルの一意の識別情報を入力してください。',
  app_inputPkg: 'パッケージ名を入力してください',
  app_noVerTag: 'バージョンの識別がありません',
  app_noresetfs: '設備は現在工場状態ですので、管理者に連絡してクリアしてください',
  app_saleSt: '出荷状態',
  app_actst: 'アクティブ状態',
  app_inputIntrol: '説明を入力してください',
  app_selectType: 'アプリケーションの種類を選択してください。',
  app_ulApp: 'アプリケーションをアップロードしてください',
  app_ulIcon: '小さいアイコンをアップロードしてください',
  app_ulLarIcon: '大きなアイコンをアップロードしてください',
  app_smVerify: '審査にかける',
  app_baseInfo: '基本情報',
  app_version: 'バージョン番号',
  app_autoUpload: '自動記入',
  app_verTag: 'バージョン識別',
  app_ID: '一意の識別情報',
  app_package: 'パッケージ名を適用',
  app_introl: 'アプリケーションの概要',
  app_udState: '説明を更新します',
  app_ulScreenShot: 'スクリーンショットをアップロードしてください',
  app_icon: '小さいアイコンを使う',
  app_larIcon: '大きなアイコンを使う',
  app_screenShot: 'スクリーンショットを使う',
  app_appVer: 'バージョンを適用',
  app_createTime: '作成時間',
  app_close: '閉じる',
  app_ulNew: '新版をアップロード',
  app_selectApp: 'アプリケーションを選択',
  app_testInstall: 'テストのインストール',
  app_ulAppState: 'ファイルをここまでドラッグする又はアップロードをクリックする,apkファイルのアップロードのみをサポートします',
  app_clickUpdate: 'クリックしてアップロード',
  app_udType: '更新モード',
  app_allUpdate: 'フル更新',
  app_asc: '昇順',
  app_desc: '降順',
  app_utasc: '時間の昇順を更新します',
  app_utdesc: '更新時間降順',
  app_iconState: '144×144、サイズ100k以内',
  app_larIconState: '512x512,サイズ200k以内',
  app_autoInstall: '自動インストール',
  app_addApp: 'アプリケーションを追加',
  app_classIntrol: 'クラス紹介',
  app_homeIntrol: 'ホームページのオススメ',
  app_isIntroClass: 'カテゴリに推薦するかどうか',
  app_isIntroHome: 'トップページに紹介しますか？',
  app_isUnbindApp: 'アプリケーションをアンインストールすることを確定しますか',
  app_isOffApp: 'このアプリケーションは今後使用できなくしますか',
  app_isDelData: 'このデータを削除しますか？',
  app_inputAName: '名前を記入してください',
  app_oneDeviceMust: '少なくとも一つのデバイスを選択',
  app_fileSize: 'ファイルサイズ',
  app_addPush: 'プッシュを追加',
  app_viewPushHis: 'プッシュ履歴を表示',
  app_pushTimes: 'プッシュ回数',
  app_hisVer: '履歴のバージョン',
  app_pushHistory: '履歴を送る',
  app_pushInstall: 'プッシュインストール',
  app_animatePush: 'アニメーション',
  app_animateMake: 'アニメーションをカスタマイズ',
  app_pushDevice: '転送済みデバイス',
  app_ustart: '開始していません',
  app_outofdate: '期限が切れています',
  app_deviceNum: '設備の数',
  app_deviceName: 'デバイス名',
  app_deviceNo: 'デバイス番号',
  app_pushTime: '時間を送る',
  app_distributor: 'ルート業者',
  app_dParent: '上級ルート商',
  app_unbind: 'アンマウント',
  app_mulUnbind: '一括アンマウント',
  app_mulPush: '一括送信',
  app_searchTerminal: 'ターミナル番号または名前検索',
  app_terName: 'ターミナル名',
  app_taskName: 'ジョブ名',
  app_taskDetail: 'タスクの内容',
  app_deviceTotal: 'デバイス総数',
  app_downloading: 'ダウンロード中',
  app_downFail: 'ダウンロード失敗',
  app_update: '更新',
  app_md5Fail: 'MD5校验失败',
  app_theNewgVer: '端末に最新バージョンがインストールされています。',
  app_fileFmIllegal: 'ファイルフォーマットが不正です。',
  app_updateFail: '更新に失敗しました',
  app_usrCancelUpdate: 'ユーザは更新をキャンセルします',
  app_pushFail: '設備がオフラインする',
  app_downFinish: 'ダウンロード完了',
  app_updateSuccess: '更新成功',
  app_fail: '失敗',
  app_addres: '住所',
  app_mulDel: '一括削除',
  app_contact: '連絡先',
  app_contactPhone: '連絡電話',
  app_typeName: 'タイプ名',
  app_customs: 'カスタム',
  app_clear: 'クリア',
  app_customsTime: 'カスタム時間',
  app_launchAnimate: 'テレビアニメ',
  app_onLogo: '機械をスタートさせるLOGO',
  app_animateName: 'アニメーション名',
  app_playPlace: '再生場所',
  app_aSrcFile: 'アニメーションリソースファイル',
  app_asfState: '动画分解画面,注意文件名一定要是 part0.zip',
  app_downExp: 'ダウンロードの例',
  app_ologoState: '動画再生停止後に表示される画面',
  app_picSize: '画像サイズ',
  app_picSizeState: '幅*高さを記入します',
  app_frame: 'フレーム数',
  app_frameState: 'アニメーションの数',
  app_aCycleTime: 'アニメーションの循環回数',
  app_cyclePlay: '繰り返し再生',
  app_playOnce: '一回再生',
  app_fileNameOnly: 'ファイル名は必ず',
  app_inputNumber: '数字を入力してください',
  app_picUlError: '画像アップロードエラー',
  app_inputAnimateName: 'アニメーション名を入力してください。',
  app_selectAnimateType: 'アニメーションの種類を選択してください。',
  app_selectPlayPlace: '再生場所を選択してください。',
  app_uploadAnimateFile: '動画ファイルをアップロードしてください。',
  app_uploadOnPic: 'ブート画像をアップロードしてください。',
  app_sureDelTip: '削除確定しますか、削除後は復帰できません',
  app_uploadPic: '画像をアップロードしてください',
  app_launchUI: '起動画面',
  app_amechine: '台',
  app_chooseCycleType: 'ループ方式を選択してください。',
  app_formatNotTrueLike: '書式が正しくない、例えば',
  app_on: '機械をスタートさせる',
  app_off: '電源を切る',
  app_onOff: 'スイッチ？マシン',
  app_firm: 'メーカー名',
  app_terstatus: 'ターミナル状態',
  app_fminfo: 'ファームウェア情報',
  // 2017-7-28 wei add
  add_srcFwByName: '名称でファームウェアを検索',
  app_downNum: 'ダウンロード回数',
  app_pushed: 'リリース済み',
  app_notPass: '不合格',
  app_sysType: 'システムのタイプ',
  app_sys: 'システム',
  app_sysUdPack: 'システムアップグレードパッケージ',
  app_chooseFile: 'ファイルを選択',
  app_signCer: '署名証明書',
  app_isUseDisCerAutoSign: 'ルート商取引証明書を使って自動署名をするかどうか',
  app_useDis: '指定ルート商',
  app_allDisUsed: 'すべてのルート商が共通している。',
  app_pushInstallTest: 'プッシュアップインストールテスト',
  app_firmware: 'ファームウェア名',
  app_pushType: 'プッシュタイプ',
  app_dv: 'デバイス',
  // 2017-7-31 wei add
  app_fwType: 'ファームウェアの種類',
  app_ulNormalSt: 'ファイルをここにドラッグする又はアップロードをクリックする',
  app_selectChannel:'ルート商を選んでください',
  app_isSubmitToCheck: '審査を提出するかどうか',
  app_pleaseInputNo: '端末番号を入力してください。',
  // 2017-8-7 wei add
  app_cnAndActive: 'オンラインアクティブ',
  app_clearCer: '証明書のクリア',
  app_ofCheck: 'スイッチチェック',
  app_normal: '正常',
  app_insfail: 'インストールに失敗しました',
  app_checksignfail: '検札に失敗する',
  app_netStatus: 'ネットワーク状態',
  app_active: 'アクティブ',
  app_initiative: '主動的である',
  app_selfDestroy: '身を滅ぼす',
  app_mulActive: '一括アクティブ',
  app_selected: '選択済み',
  app_cerCheckOf: '検札スイッチ',
  app_openCerCheck: '検札を開く',
  app_closeCerCheck: '検札を閉じる',
  app_reOpen: '再開',
  app_reClose: '再閉じる',
  app_open: '開く',
  app_usrManage: 'ユーザー管理',
  app_stManage: '設定管理',
  app_roleManage: 'キャラクター管理',
  // 2017-8-8 wei add
  app_cerMgType: '証明書の管理タイプ',
  app_cerMgSelf: '自己管理証明書',
  app_cerMgOther: '証明書を管理します',
  app_cerMgCustomer: '証明書を管理します',
  app_operateHis: '操作履歴',
  app_operateType: '操作の種類',
  app_time: '時間',
  app_isActive: '本当にアクティブにしますか',
  // 2017-8-8 wei add
  app_downCer: '証明書をダウンロード',
  // 2017-8-10 wei add
  app_isOperate: '操作は確実ですか？',
  // 2017-8-11 wei add
  app_ulSuccess:'アップロード成功',
  // 2017-7-31 wei add
  app_setting: '設定',
  // 2017-8-15 wei add
  app_clickPicToUlPic: '画像の位置をクリックして画像をアップロードします。',
  app_within: '以内の',
  app_pgsFormat: 'png、gif、svg書式',
  app_sgUseAndAdUse: 'svg形式、画像の色は白をおすすめです',
  app_sureChange: '変更の確認',
  app_logoLvTip: '保存されていない変更があります',
  app_dfIcon: '標準アイコン',
  // 2017-8-16 wei add
  app_useBigSize: '大きいサイズを使う',
  app_useBigSizeTip: 'ロゴはこの改善を視覚的に小さい時に選択してください',
  // 2017-8-22 wei add
  app_or: 'または',
  app_format: '書式',
  app_pic: '画像',
  app_s: 'の',
  app_plsUpl: 'アップロードしてください',
  // 2017-8-24
  app_upload:'アップロード',
  app_cerType:'証明書の種類',
  // 2017-8-31
  app_editProfile: '資料を編集する',
  // 2017-9-1
  app_cerFile: '証明書ファイル',
  app_plsUlPbCer: 'クライアント証明書をアップロードしてください。',
  app_appNoCerTip: '現在のルート業者は自管証明書の取引先で、公開鍵ファイルをアップロードして、応用検証署名を行ってください',
  app_appNeedCerTip: '現在のルート業者には証明書がありませんので、プラットフォーム管理者に連絡して作成してください',
  app_createCer: '証明書を作成',
  app_uploadCer: '証明書をアップロード',
  // 2017-9-4
  app_fileImport: 'ファイルのインポート',
  app_mdFile: '模版ファイル',
  app_down: 'ダウンロード',
  // 2017-9-5
  app_roleAllot: '役を振る',
  app_roleName: 'キャラクター名',
  app_downTplFile: 'テンプレートファイルをダウンロード',
  // 2017-9-7
  app_verUdCt: 'バージョンの更新',
  app_animation: 'アニメーション',
  app_per: '各',
  app_geo: '地理の位置',
  app_minute: '分',
  app_hbsp: 'ときめきの間隔',
  app_rcmsg: '情報を受信する',
  app_autoRefresh: '自動更新',
  app_checkupsp: '更新間隔を確認',
  app_level: 'レベル',
  app_firm: 'メーカー',
  app_model: 'モデル',
  app_adType: '広告の種類',
  app_license: '認証コード',
  app_maintain: 'メンテナンス',
  app_manage: '管理',
  app_is: 'かどうか',
  app_plsip: '記入してください',
  app_reason: '理由',
  // 2017 9-26
  app_sgMc: '単台設備',
  app_ss: '概要',
  app_inst: 'インストール',
  app_file: 'ファイル',
  app_printscreen: 'スクリーンショット',
  app_batch: 'ロット',
  app_recov: '元に戻す',
  app_lc: 'launcher',
  // 2017 10-11
  app_re: '新規作成',
  app_sysinfo: 'システム情報',
  app_confirm: 'ヒント',
  app_df: 'デフォルト',
  app_as: 'を選択します',
  app_click: 'クリック',
  app_content: '内容',
  app_ttPkg: 'フルパッケージ',
  app_dfPkg: '下請け',
  app_task: 'ジョブ',
  app_catch: 'キャプチャ',
  app_log: 'ログ',
  app_continued: '継続',
  app_sec: '秒',
  app_video: '動画リスト',
  app_ad: '広告',
  // 2017 10-25
  app_choose: '選択',
  app_timeInterval: '期間',
  app_and: '和',
  app_play: '再生',
  app_times: '回数',
  app_sc: '次数',
  app_tofvalis: '有効期間',
  app_tofvaliss: '有効期限',
  app_start: '開始',
  app_end: '終了',
  app_preview: 'プレビュー',
  app_duration: '長さ',
  app_size: 'サイズ',
  app_personnel: '人員',
  app_cannot: 'できません',
  app_early: '早ければ',
  app_later: '後に',
  app_lessThan: '以下',
  app_moreThan: '大きい',
  // 2017 11-14
  app_nums: '数量',
  app_waiting: '待っています',
  app_all: '全部',
  app_all1: 'すべて',
  app_thistime: '今回',
  app_done: '完了',
  app_areyou: 'あなたが欲しいです',
  app_skip: 'スキップ',
  app_these: 'これら',
  app_cover: '上書き',
  app_jump: 'ジャンプ',
  app_detail: '詳細',
  app_view: '表示',
  app_now: 'すぐに',
  app_imp: 'インポート',
  app_size1: 'サイズ',
  app_taskMg: 'タスク管理',
  app_inssuccess: 'インストール成功',
  app_taskType: 'タスクの種類',
  app_cancelPush: '配達を取り消す',
  app_iscancelPush: 'プッシュをキャンセルしますか',
  app_azcgsj: 'インストール成功時間',
  app_ispushf: 'ファイルを転送するかどうか',
  app_autoscopen: '自動でインストールできました。',
  app_pushsctipinstall: '成功した端末をプッシュしてアプリケーションのダウンロードを促す。',
  app_tipdown: 'ヒントダウンロード',
  app_tipud: 'ヒントインストール',
  app_bth: 'ホームページに戻ります',
  app_norightview: 'このページにアクセスする権限がありません。',
  // 2017 11-27
  app_fault: 'エラー',
  app_abnormal: '異常',
  app_blockp: '紙を引っ掛ける',
  app_ecr: '電気カードリーダー',
  app_mcr: 'カードリーダー',
  app_nacr: 'カードリーダーではない',
  app_cardr: 'カード？ホルダー',
  app_tgcr: '二世代認証リーダー',
  app_receiptp: 'このプリンタで',
  app_ispushalldv: 'すべてのデバイスを転送するかどうか',
  //edit lin
  lin_btn:{
    cancel: "キャンセル",
    add: "追加",
    install:'インストール',
    batch_install:'一括インストール',
    tips:'ヒント',
    confirm:'ヒント',
    unbind:'縛りを解く',
    unbindAll:'ロット解除',
    check:'クエリー',
    reset:'リセット',
    submit:'送信',
    restart:'再起動',
    off:'閉じる',
    send:'押して送る',
    batch_delete:'一括削除',
    delete:'削除',
    lock:'アンカー',
    lockOta:'アンカーOTA',
    add_zeng:'増加',
    edit:'編集',
    save:'保存',
    bind:'結合',
    //20170727追加edit by linziying
    bindAll:'一括結合',
    xiezai:'アンマウント',
    unlock:'錠をはずす',
    change:'変更',

  },
  lin_global:{
    cs_config: 'パラメータ設定',
    task_tips:'実装に成功したので,タスク管理中にプッシュの進捗を見てください',
    task_tips2:'プッシュ成功,タスク管理中に推送の進捗を見てください',
    ope:'操作',
    pselect:'選択してください',
    label_no:'デバイス番号',
    loading:'データロード中',
    label_name:'デバイス名',
    all_mechanism:'あらゆるルートの商人',
    place_areaid:'ルート商を選んでください',
    time:'時間',
    version:'バージョン',
    name:'名前',
    remark:'コメント',
    edit:'編集',
    label_model:'デバイス型式',
    label_type:'デバイスのタイプ',
    label_manufid:'設備メーカー',
    label_areaid:'ルート業者',
    label_areaid_name:'ルート商名',
    label_address:'デバイスアドレス',
    ter_status:'デバイスの状態',
    net_status:'ネットワーク状態',
    run_status:'外部設定の状態',
    online:'オンライン',
    offline:'オフライン',
    new_add:'追加',
    normal:'正常',
    marn:'警戒する',
    fault:'エラー',
    success_tips:'操作が成功しました',
    concel_tips:'キャンセルしました',
    zlxfs_tips:'キャンセルしました',
    sb_tips:'操作が失敗,端末がオフラインになりました',
    czsb:'操作に失敗しました',
    zl_error:'命令でエラーが発生しました',
    all_status:'すべての状態',
    delete_success:'削除に成功しました',
    look_detail:'詳細を表示',
    ter_num:'設備の数',
    ota_bao:'OTA包',
    ple_sel_ota:'OTAパッケージを選択してください',
    unlock_success:'ロック解除成功',
    risk_name:'名前を設定',
    risk_type:'アラームタイプ',
    risk_radius:'フェンス半径(KM))',
    risk_city:'省市を設定する',
    risk_desc:'説明',
    risk_warn_info:'風控警報情報',
    warn_event:'早期警戒事件',
    city:'都市',
    jwd:'経緯度',
    distance:'設定距離(KM)を超えました',
    ccwl:'柵を越える',
    sbyj:'設備警告',
    done:'処理済み',
    undone:'未処理',
    roles_tips:'キャラクターを選んでください',
    roles_place:'ニックネームで検索',
    userName:'ユーザ名',
    nickName:'ニックネーム',
    phoneNum:'携帯電話',
    roleName:'キャラクター',
    jh:'アクティブ',
    dj:'凍結する',
    phoneNum2:'携帯の番号',
    resetPass:'パスワードをリセット',
    revisePass:'パスワードを変更',
    oldPass:'古いパスワード',
    newPass:'新しいパスワード',
    comfirmPass:'パスワードを確認する',
    plePassTips:'パスワードを入力してください',
    plePassTipsAgain:'パスワードをもう一度入力してください。',
    pwdDisfault:'二回の入力パスワードが一致しません。',
    unfitPhone:'携帯の番号は合法的ではないです。',
    nickNameTips:'ニックネームは空ではありません',
    userNameTips:'ユーザ名は空ではありません。',
    phoneNumTips:'携帯の番号は空いてはいけません。',
    roleidTips:'キャラクターは空にできません',
    mechanismIdTips:'ルート商は空ではだめです。',
    userStatusTips:'ユーザ状態を設定してください。',
    editPage:'ページを編集',
    addPage:'ページを追加',
    status:'状態',
    refs:'資料を完備してください',
    user:'アカウント',
    logStartTime:'ログ開始時間',
    logEndTime:'ログ終了時間',
    download:'ダウンロード',
    ddsc:'アップロードを待つ',
    scz:'アップロード中',
    scsb:'アップロードに失敗しました',
    sccg:'アップロード成功',
    rz_tips:'ログ取得に成功しました、ログ管理中にダウンロードの進捗を確認してください',
    hqrz:'ログを取得',
    logoTitle:'スマートPOS端末管理プラットフォーム',
    hello:'こんにちは',
    wdzl:'私の資料',
    tcxt:'システムを終了',
    yhdl:'ユーザー登録',
    zh:'アカウント',
    password:'パスワード',
    jzmm:'パスワードを覚えてください',
    login:'ログイン',
    bah:'深セン市証通電子株式会社は199-2020著作権所有の広東ICP準備12035887号です。',
    qsrzh:'アカウントを入力してください',
    qsrmm:'パスワードを入力してください',
    error:'エラー',
    wlzt:'ネットワーク状態',
    ckxq:'詳細を表示',
    wlmc:'フェンスの名前',
    wllx:'バーの種類',
    bdsb:'バインディングデバイス',
    tjbd:'バインディングを追加',
    bjwl:'フェンスを編集',
    wxzyjlx:'アラームタイプを選択してください。',
    cityName:'都市の名前',
    sfjxpljb:'一括解除を行っていますか？',
    qxzyjbdzd:'接続を解く端末を選択してください。',
    jbcg:'縛りを解くことに成功した',
    sfjbczd:'この端末を紐付けますか？',
    sfjxplbd:'一括バインディングを行うかどうか',
    qxzybddzd:'バインディングする端末を選択してください。',
    bdcg:'バインディング成功',
    sfbdczd:'このターミナルをバインドするかどうか',
    xzwl:'フェンスを追加',
    qdxysccwl:'この枠を削除する必要があることを確認します。',
    tsazcs:'プッシュアップインストールテスト',
    shzt:'状態を確認する',
    pass: "通過する",
    notPass: "パスしない",
    waitOne: "審問を待つ",
    waitTwo: "審査待ち",
    shyy:'原因を審査する',
    zdtslb:'端末プッシュリスト',
    xztghbtg:'通過または不合格を選択します。',
    qrtj:'提出の確認',
    shcg:"審査に成功しました",
    syqdsty:'すべてのルート商が共通している。',
    notBlankName: "名前は空ではない",
    notBlankVer:'バージョン番号は空にできません。',
    qxzlx:'タイプを選択してください',
    qxzscwj:'アップロードファイルを選択してください。',
    zdqds:'指定ルート商',
    sfsyzdqm:'ルート商取引証明書を使って自動署名をするかどうか',
    qmzst:'署名証明書',
    azbdz:'パッケージの住所',
    qscapkwj:'apkファイルをアップロードしてください、５０M以内',
    qsczipwjls50:'zipファイルをアップロードしてください、５０M以内',
    jwjtdcc:'ファイルをここにドラッグする、または',
    djsc:'クリックしてアップロード',
    xgscwj:'アップロードファイルを変更',
    otaName:'名前',
    xtlx:'システムのタイプ',
    syatemR:'システムROM',
    sysjota:'システムアップグレードパッケージOTA',
    waitOne: "審問を待つ",
    waitTwo: "審査待ち",
    verifyPass: '通過する',
    verifyNotPass: 'パスしない',

    confirmDelete: "削除を確定しますか",
    tjshcg:'提出審査に成功しました',
    qdtjsh:'確認提出審査',
    allType:'すべてのタイプ',
    smVerify: '審査にかける',
    downNumber:'ダウンロード回数',
    tgmccz:'ダウンロード回数',
    upload:'アップロード',
    xzqddhwj:'起動アニメーションファイルを選択',
    qxzkjlogo:'起動ロゴを選択してください',
    tpxzds:'画像の最適サイズは300×300であり,2m以内',
    zmlaun:'カスタマイズデスクトップlauncherを選択する',
    xtjcb:'システムベースパックを選択',
    null:'なし',
    shebei:'デバイス',
    tslxxx:'プッシュタイプ',
    xzbbbbb:'OTAパッケージを選択する',
    uploadTime: "アップロード時間",
    verTips:'このバージョンに基づいて生成された差分パケットは、バージョン番号にvやversionなどの文字を持たず、2.2.4のような単純な数字である',
    verTips1:'バージョン番号は、2.2.4のように、vやversionなどの文字を持たない',
    bbhgsbd:'バージョン番号のフォーマットが間違っています。',
    lkymtips:'ファイルがアップロードされていて、そのページを去るかどうかが確定しています',
    znscziptips:'zipファイルしかアップロードできません',
    qsczipwj:'zipファイルをアップロードしてください',
    //20170727追加edit by linziying
    danweikm:'単位KM',
    weilanshuoming:'説明:設備の最後の心拍の緯度経度をフェンスの中心とする',
    pleaseUpload:'アップロードしてください',
    zdqmTips:'チャンネル事業者証明書をバインドするかどうか自動署名します。',
    zhidingqdsxx:'指定チャネルの情報',
    selectWenjian:'ファイルを選択',
    qrjxmm:'このコマンドの実行を確認する',
    cicaozuo:'操作？',
    shebeiedit:'デバイス編集',
    yxpztitle:'メールボックスの設定',
    yjyouxiang:'警報メールボックス',
    chongzhi:'リセット',
    ljchangjian:'すぐに作成します',
    ympeizhi:'ドメインの設定',
    fwqdizhi:'サーバのアドレス',
    fwqdztips:'アドレスは、「http://」の文字を入れる必要はありません。ドメイン名アドレスでも、IPアドレスでもあります。例えば、www.baidu.com、127.0.0.1',
    fwqduankou:'サーバポート',
    duankoutips:'ポート番号は":"直接数字を記入しないでください。例:8080',
    tuisongpeizhi:'プッシュプロファイル',
    tuisongjl:'プッシュ記録',
    tuisonglx:'プッシュタイプ',
    chenggong:'成功',
    shibai:"失敗",
    tuisongtime:'時間を送る',
    chongtui:'押し直す',
    shebeibei:'デバイス',
    fwqdzbnwk:'サーバのアドレスが空ではありません。',
    fwqdkhbnwk:'サーバポート番号は空ではありません。',
    wdct:'再押しを決定',
    tuisongtips:'以下のドメイン名の設定を実施するかどうかは、実施が成功した後に再開される',
    //20170731 lin add
    china:'中国語',
    english:'英語',

    //20170804 lin add
    cjzs:'証明書を作成',
    createTime:'作成時間',
    certificateName:'証明書の名前',
    xiafa:'髪をおろす',
    dachuzhengshu:'証明書をエクスポート',
    guojia:'国家',
    shengfen:'省',
    gongsi:'会社',
    youxiang:'メールボックス',
    youxiaoqi:'有効期間',
    certTypeLabel: '証明書の種類',
    certForManufacturer: 'メーカー証明書',
    certForCustomer: 'クライアント証明書',
    danweitian:'单位：天',
    xinjian:'新規作成',
    notNull:'暇ではない',
    bitian:'必要とする',
    guojiatips:'国家略称，例えばCN',
    shenfentips:'省の英語/ピンイン、例えばGuangDong',
    cityTips:'シティの英語/ピンイン、例えばGuangDong',
    gongsiTips:'会社の英語/ピンイン、例えばSZZT',
    emailTips:'メールアドレスを入力してください。',
    youxiaoqiTips:'証明書の有効期限を入力してください、例えば３６５',
    xuantian:'記入する',
    srgsbzq:'入力フォーマットが不正です。',
    cszss:'メーカー証明書',
    khzss:'クライアント証明書',
    sccszss:'メーカー証明書をアップロードします',
    zhengshu:'証明書',
    qudaoshangxinxi:'ルート業者',
    quorter:'ルート商を選んでください。または設備番号を記入してください。',
    xiafalishi:'送信履歴',
    resXiafa:'再発行',
    chongxintuisong:'改めて送ります',
    tuisongleixing:'プッシュタイプ',
    dachusiyao:'秘密鍵をエクスポート',
    shuaxin:'リストを更新',
    passWordTips:'パスワードが空です',
    //20170804 lin add end

    //20170821 lin add
    daochugongyao:'証明書をエクスポート',
    //20170821 lin add end


    //20170822 lin add
    zhengshuType:'ルート商証明書の種類',
    ziguan:'自己管理',
    daiguan:'管理を代行する',
    //20170822 lin add end

    //20171023 add by sing
    add_merchant: 'ルート商を追加する',


  },
  //edit lin
  terminal: {
    //デバイスを追加

    add:{
      //label值
      //放在global

      //placeholder值
      place_no:"設備番号を入力してください",
      place_name:'デバイス名を入力してください',
      place_terminal:'デバイスを選択してください',
      place_model:'設備の型番を選択してください',     //also rules
      place_type:'設備タイプを選択してください',      //also rules
      place_manufid:'メーカーを選んでください',      //also rules
      //also rules
      place_address:'設備のアドレスを入力してください',  //also rules
      //popover值
      popover_no:'装置番号は長さが50桁以下のアルファベット、数字、下線で構成されている',
      popover_name:'装置名は長さが50桁以下の漢字、アルファベット、数字、下線で構成されている',
      //校验规则
      rules_no_1:'設備番号は空にできません。',
      rules_no_2:'設備番号の長さは、20ビット以上であってはならない',
      rules_no_3:'設備番号は、アルファベット、数字、または下線で構成される',
      rules_no_4:'設備番号が存在しています',
      rules_name_1:'デバイス名は空です。',
      rules_name_2:'設備名の長さは30ビット以上であってはならない',
      rules_name_3:'設備名は漢字、アルファベット、数字、下線からなる',
      //提交弹出提示
      success:'追加成功',
      change_success:'修正成功',


    },
    appBind:{
      label_name:'名前を適用',
      label_version:'バージョン番号',
      label_size:'サイズを適用',
      place_name:'アプリケーション名の検索を入力します。',
      empty_tips:'バインディングのアプリケーションを選択してください',
      install_tips:'インストールが必要かどうか',
      five_tips:'一回のバインディングの応用は5つを超えてはいけません。',

    },
    appList:{
      label_name:'名前を適用',
      label_type:'タイプを適用',
      label_version:'バージョン番号',
      label_time:'バインディング時間',
      format_status1:'一般的なアプリケーション',
      format_status2:'システム応用',
      tips1:'このアプリケーションをアンマウントする必要があると確定しました。',
      tips2:'バインディング解除成功',

    },
    appLog:{
      start_time:'開始時間',
      end_time:'終了時間',
      log_type:'ログのタイプ',
      log_content:'ログの内容',


      num:'設備の数',
      tower:'台',

    },
    details:{
      regain:'出荷時設定を復元',
      run_log:'実行ログ',
      risk_info:'ファン情報',
      app_list:'適用リスト',
      app_install:'アプリケーションのインストール',
      send_animate:'アニメーションを送る',
      reset_animate:'アニメーションを復元',
      base_info:'基本情報',
      system_info:'システム情報',
      launcher:'launcherバージョン',
      system_version:'システムバージョン',
      ota_version:'OTAバージョン',
      hard_version:'ファームウェアバージョン',
      last_time:'最終更新日時',
      net_type:'ネットワークタイプ',
      online_time:'オンライン時間',
      run_time:'運転時間が長い',
      hard_info:'ハードウェア情報',
      cpu:'CPU信息',
      mem:'メモリ情報',
      cpuUsed:'CPU使用率',
      memUsed:'メモリ使用率',
      hydh:'アニメーションを復元',
      tips:'アニメーションの復元タイプを選択してください。',
      kjdh:'動画リスト',
      gjdh:'アニメーションをオフにする',
      kjlogo:'機械をスタートさせるLOGO',
      alldhlogo:'所有(动画和LOGO)',
      zbhy:'しばらく還元しない',
      mshy:'すぐに元に戻ります',
      tsdh_title:'アニメーションを送る',
      animate_name:'アニメーション名',
      animatType:'タイプ',
      position:'再生場所',
      createTime:'カスタム時間',
      animate:'アニメーション',
      kjlogo:'機械をスタートさせるLOGO',
      kj:'機械をスタートさせる',
      gj:'電源を切る',
      kgj:'スイッチ？マシン',
      com_send: '確定プッシュ',
      cover_send: '上書きプッシュ',
      skip_send: 'プッシュをスキップする',
      comfirm_send:'この動画を配信しますか',
      comfirm_hy:'この動画像を復元することを確認しますか',
      hy_success:'復元に成功しました',
      hy_type:'元に戻すアニメーションタイプを選択してください。',
      open_abd:'開くADB',
      close_abd:'閉じるADB',
      if_ope:'この操作を行うかどうか',

    },
    list:{
      add_btn:'デバイスを追加',
      import_btn:'デバイスをインポート',
      ztgxsj:'状態更新時間',
      import_title:'デバイス情報をインポート',
      xqwj:'ファイルを選択',
      qrdr:'インポートの確認',
      import_muban:'インポートテンプレートをダウンロード',
      notify_title:'インポート結果のヒント',
      delete_tips:'この操作は、設備を永続的に削除しますので、継続しますか',
      deletes_tips:'この操作は、設備を永続的に削除しますので、継続しますか',
      empty_tips:'削除するデバイスを選択してください。',
      /*20170731新加*/
      excel_tips:'Excelファイルのみアップロードできます。しかも10 Mを超えません',

    },
    OtaList:{
      lock_num:'ロックデバイス数',
      lock_tips:'OTAを解除しますか',

    },
    terRisk:{
      fkpz:'ファンクションの設定',
    }
  },
  account:{
    delete_tips:'このユーザを削除する必要があると確定しました。',
  },
  // edit mao
  mao_global: {
    btn: {
      sort: "排序",
      e: "操作",
      cancel: "キャンセル",
      add: "追加",
      edit: "編集",
      submit: "送信",
      update: "変更",
      delete: "削除",
      ok: "ヒント",
      selectAll: "すべて選択",
      unSelectAll: "すべて選択しない",
      reset: "リセット",
      createNow: "すぐに作成します",
      confirmUpdate: "修正を確定する"
    },
    tip: {
      text: "ヒント",
      confirmDelete: "削除を確定しますか",
      examine: "審査する",
      pleaseSelect: "選択してください",
      pleaseInput: "入力してください",
      search: "クエリー",
      notBlank: "暇ではない",
      success: "成功",
      fail: "失敗",
      notPassExamine: "未審査通過",
      groundsForRefusal: "拒絶理由を記入してください",
      notReset: "削除後は復帰できません"
    }
  },
  /*菜单*/
  menu: {
    home: "ホーム",
    terManage: "設備管理",
    terManageSub: {
      myTer: "私の設備",
      breakup: "端末のバックアップ",
      lockOTA: "端末ロック",
      map: "端末マップ",
      log: "ログ管理",
      addTer:"デバイスを追加",
      detailTer:"终端详情",
      riskInfo:"ファン情報",
      runLog:'実行ログ',
      appList:'適用リスト',
      appInstall:'アプリケーションのインストール',
      otaLock:'OTAアンカー',

    },
    advertManage: "広告管理",
    advertManageSub: {
      list: "広告一覧",
      examine: "広告審査",
      examineVideo: "動画広告審査",
      examineDetail: "審査の詳細",
      edit: "编辑广告",
      editVideo: "ビデオ広告を編集",
      detail: "广告详情",
      vlist: "動画広告一覧",
      vverify: "動画広告審査",
      addVideo: "ビデオ広告を追加",
      dfVList: "デフォルトのビデオリスト",
      addDfVideo: "デフォルトのビデオを追加"
    },
    appManage: "アプリケーション管理",
    appManageSub: {
      list: "適用リスト",
      market: "アプリケーション市場",
      custom: "私のカスタマイズに追加",
      viewApp: "アプリケーションを見る",
      customPush: "カスタマイズプッシュ",
      appPush: "アプリケーションをプッシュ",
      appBind: "アプリケーションバインディング端末",
      examine: "アプリケーション審査",
      verifyApp: "審査アプリケーション",
      appEdit: 'アプリケーション編集',
      appDetail: 'アプリケーションの詳細',
      uploadNew: '新しいバージョンをアップロード',
      uploadApp: 'アップロードアプリケーション'
    },
    taskManage: "タスク管理",
    taskManageSub: {
      list: "タスクをプッシュしています",
      detail: "タスクの詳細をプッシュしています",
      listHis: "タスクを完了しました。",
      detailHis: "タスクの詳細を完了しました"
    },
    dataManage: "データ管理",
    dataManageSub: {
      channel: "ルート業者管理",
      factory: "メーカー管理",
      terClassify: "設備タイプ管理",
      terNum: "設備の型番管理",
      advertClassify: "広告タイプ管理",
      appClassify: "アプリケーションタイプ管理",
      newChannel: "ルート商を追加する",
      editChannel: "ルート業者編集",
      newFirm: "新規メーカー",
      editFirm: "メーカー編集"
    },
    railManage: "リスクマネジメント",
    railManageSub: {
      penSetting: "フェンス設置",
      warnSetting: "警報情報",
      riskDetail:"フェンスの詳細",
    },
    //lin add 20170804
    safeManage: "安全管理",
    safeManageSub:{
      certificate:"証明書の管理",
      certNew:"証明書を作成",
      remote:"リモートライセンス",
      certUpload:"メーカー証明書をアップロードします",
      certDetail:"証明書詳細",
      cerUpload:"証明書をアップロード",
      myCert:'私の証明書'
    },
    //lin add 20170804 end
    sysManage: "システム管理",
    sysManageSub: {
      romul: 'OTAアップロード',
      romed: 'OTA編集',
      romOTA: "OTA管理",
      examine: "OTA審査する",
      push: "OTA押して送る",
      order: "系统定制",
      animation: "动画定制",
      animateCustom: "アニメーションをカスタマイズ",
      animatePush: "アニメーション",
      pushHistory: "履歴を送る",
      firmwareManage: 'ファームウェア管理',
      firmwareUpload: 'ファームウェアアップロード',
      firmwareEdit: 'ファームウェア編集',
      firmwareCheck: 'ファームウェア審査',
      firmwareCheckDt: '審査の詳細',
      firmwarePush: 'ファームウェアプッシュ',
      firmwarePushDevice: 'ファームウェアプッシュデバイス',
      launchManage: 'launcher管理',
      launchCheck: 'launcher審査する',
      verifyLaunch: '審査するlauncher',
      addLaunch: '追加launcher',
      launchDetail: 'launcher詳細',
      launchEdit: 'launcher編集',
      launchNewVer: 'launcher新版をアップロード',
      launchPush: 'Launcher押して送る',
      launchPushTer: 'Launcher推送终端'
    },
    setManage: "設定管理",
    setManageSub: {
      role: "キャラクター管理",
      system: "システム構成",
      menu: "メニューリスト",
      addRole: "キャラクター追加",
      rightChange: "権限改正",
      logo: 'LOGO設定'
    },
    accManager: "アカウント管理",
    accManagerSub: {
      account: "アカウント情報",
      subAccount: "サブアカウント情報",
      addAccount:'サブアカウントを追加',
      editAccount:'サブアカウントを編集',
    },
    menuEdit: 'メニュー編集'
  },
  /*菜单 END*/
  /*広告*/
  advert: {
    status: "広告の状態",
    addAdvert: "新增广告",
    deleteAll: "一括削除",
    all: "全部",
    refusal: "理由を説明する",
    app: "適用",
    appSub: {
      name: "名前",
      classify: "タイプ",
      uploadTime: "アップロード時間",
      version: "バージョン番号"
    },
    isPass: "通過するかどうか",
    pass: "通過する",
    notPass: "パスしない",
    waitOne: "審問を待つ",
    waitTwo: "審査待ち",
    addDate: "時間を追加",
    addUser: "添加者",
    appName: "名前を適用",
    img: "画像",
    name: "広告の名前",
    classify : "広告の種類",
    position : "广告位置",
    positionSub: {
      banner: "トップページバナー",
      starPage: "ランチャーページ"
    },
    jumpType: "ジャンプタイプ",
    jumpTypeSub: {
      net: "サイト",
      appStore: "アプリケーション市場"
    },
    url: "URL",
    channel: "チャンネル",
    ableDate: "有效时间",
    beginDate: "開始時間",
    endDate: "終了時間",
    contentImg: "広告内容",
    reset: "リセット"
  },
  /*広告 END*/
  /*首页*/
  index: {
    t: "台",
    more: "もっと",
    terStatus: "設備概況",
    onlineTer: "オンライン設備",
    offLineTer: "オフライン設備",
    warnTer: "警報設備",
    taskList: "タスクリスト",
    pullApp: "アプリケーション発行",
    romUpdate: "ROM更新",
    pullAdvert: "広告送り",
    infoList: "情報リスト",
    riskWarn: "リスクコントロール警告",
    breakWarn: "故障警告"
  },
  /*首页 END */

  /*設定管理*/
  menuConfig: {
    menu: {
      addMenu: "親メニューを追加する",
      addMenu2: "メニューを追加する",
      refreshMenu: "メニューを刷新する",
      menuName: "メニュー名",
      selectModel: "モジュールを選択してください",
      orderBy: "順序番号",
      notBlankName: "名前は空ではいけない",
      editMenu: "編集メニュー",
      editSuccess: "編集成功",
      addSubMenu: "サブメニューの追加",
      relUrl: "相対アドレス"
    },
    // 配置管理 - 角色管理
    role: {
      addRole: "新規キャラクター",
      no: "番号付け",
      name: "名前",
      mark: "説明",
      model: "モジュール",
      updatePermission: "権限修正",
      editRole: "キャラクター編集",
      notBlankName: "名前は空ではない",
      updateSuccess: "更新成功",
      deleteSuccess: "削除に成功しました",
      modelSelect: "モジュール選択",
      addSuccess: "追加成功"
    }
  },
  /*設定管理 end*/

  /* タスク管理 */
  /* add by sing, 2017-10-26 */
  taskTypeNames: {
    ALL: "すべてのタイプ",
    APP: "適用",
    OTA: "OTA",
    ROM: "ROM",
    FIRMWARE: "ファームウェア",
    AD: "広告",
    STARTUP_ANIMATION: "動画リスト",
    SHUTDOWN_ANIMATION: "アニメーションをオフにする",
    STARTUP_SHUTDOWN_ANIMATION: "テレビアニメ",
    LOGO: "機械をスタートさせるLOGO",
    LAUNCHER: "Launcher",
    WALLPAPER: 'デスクトップの壁紙'
  },

  app_adname: '広告の名前',
  app_allpush: '全部送る',
  app_fipush: 'ファイルのインポートと転送',
  app_isjtoviewtd: 'タスクにジャンプするかどうかは、転送の進捗を確認します。',
  app_mgsys: 'タスクにジャンプするかどうかは、転送の進捗を確認します。',
  app_edcode: '保守授権コード',
  app_sapp: 'アプリケーションを選択してください',
  app_spic: '画像を選択してください',
  app_iappnamesrch: 'アプリケーション名クエリを入力してください。',
  app_alltyps: 'すべてのタイプ',
  app_allpp: 'すべての再生場所',
  app_addur: '広告の時間',
  app_vsize: '動画サイズ',
  app_addtime: '時間を追加',
  app_psverify: '審査に通る',
  app_vpreview:'動画リスト',
  app_cstandt: '選択時の長さと回数',
  app_additv: '追加時間',
  app_vdofile: '動画ファイル',
  app_filename: 'ファイル名',
  app_vdodur: '動画リスト',
  app_misstokentip: 'ログイン情報を失ったため、再度ログインする必要があります',
  app_clreulvdo: 'クリックしてビデオを再アップロードします。',
  app_adddfvdeoad: 'デフォルトのビデオ広告を追加します。',
  app_addps: '人員を追加する',
  app_pltimes: '再生回数',
  app_pldur: '再生時間が長い',
  app_csvldate: '有効期間を選択',
  app_advdoad: 'ビデオ広告を追加',
  app_mgdfvdo: 'デフォルトのビデオを管理',
  app_adstatus: '広告の状態',
  app_addadtype: '広告の種類を追加',
  app_newapptype: 'アプリケーションの種類を追加',
  app_addmodel: 'モデルを追加',
  app_newdvtype: 'デバイスタイプを追加',
  app_addfmname: '新規メーカー名',
  app_srpush: 'プッシュを確認する',
  app_ulfile: 'ファイルをアップロード',
  app_ttpsddvnum: '今回の押送完了設備数',
  app_srsktsdv: 'これらのデバイスをスキップしたのは確かです。',
  app_cvpush: '上書きプッシュ',
  app_skpush: 'プッシュをスキップする',
  app_pssuccess: 'プッシュ成功',
  app_nowjump: '直ちにジャンプ',
  app_bcrecov: 'ロット還元',
  app_skintro: '概要',
  app_addlc: '追加launcher',
  app_ulinsfile: 'アップロードインストールファイル',
  app_clreul: 'クリックして再アップロードします',
  app_lcname: 'launcher名前',
  app_rsfivemin: '每5分钟自动刷新',
  app_suresm: '提出の確認',
  app_udfiletype: 'ファイルタイプを更新',
  app_plsltype: 'タイプを選択してください',
  app_adnamenotnull: '広告名は空にできません。',
  app_plslchannel: 'ルート商を選んでください',
  app_plslplpos: '再生場所を選択してください。',
  app_slsttime: '開始時間を選択してください。',
  app_slendtime: '終了時間を選択してください。',
  app_addsc: '追加成功',
  app_vlsuccess: '審査に成功しました',
  app_opsuccess: '操作が成功しました',
  app_srpassvf: '承認確認',
  app_addvdoad: 'ビデオ広告を追加',
  app_edvdoad: 'ビデオ広告を編集',
  app_sllimit: '有効期間を選択',
  app_srmuldel: '一括削除確認',
  app_sttcanlateendtime: '開始時間は終了時間より遅くてはいけません。',
  app_etcanelsttime: '終了時間は開始時間より早くしてはいけません。',
  app_srdelpush: '終了時間は開始時間より早くしてはいけません。',
  app_srrecovsysdf: 'システムのデフォルトに戻すことを確認します。',
  app_rdless: 'フェンスの半径が小さい',
  app_rdneedmore: 'フェンスの半径が大きい必要があります。',
  app_srban: '確認が不合格です',
  app_banandrs: 'パスしない?原因を入力しない',
  app_trjmap: '軌跡マップ',
  app_psdonelftip: '今回の推送は{num}台の設備がすでに推送を完了してあるいは推送しているが、これらの設備をスキップしますか?',  // app_ttpsddvnum
  app_psscandtip: 'プッシュ成功ヒントインストール',
  app_csulpicbsis: 'クリックしてアップロード（jpg、png、gif…）、最適表示サイズは',
  app_srch: '検索',
  app_lkdevice: 'デバイスを検索',
  app_app: '適用',
  app_firmw: 'ファームウェア',
  app_refresh: '更新',
  app_sleep: 'スリープ',
  app_ccdown: 'ダウンロードをキャンセル',
  app_srchcontent: '検索内容',
  app_account: 'アカウント',
  app_opecontent: '操作内容',
  app_opetime: '操作時間',
  app_frzaccount: 'アカウントを凍結する',
  app_operator: 'オペレーター',
  app_userip: 'ユーザーIP',
  app_deskwp: 'デスクトップの壁紙',
  app_channelmcdetail: 'ルートの詳細',
  app_channellevel: 'ルート商の等級',
  app_cermanage: '証明書の管理',
  app_lineimportcer: 'ラインインポート証明書',
  app_devicemanage: '設備管理',
  app_fileimportdevice: 'ファイルインポートデバイス',
  app_lineimportdevice: 'ライン導入設備',
  app_prodmodel: '製品の種類',

  app_plimportcer: '生産ライン導入顧客証明書',
  app_importslorder: '選択した注文をインポートします',
  app_importslcustomer: '選択したクライアントをインポート',
  app_customername: '顧客名',
  app_orderno: '注文番号',
  app_orderfinishdate: '注文完了日',
  app_customerno: '顧客コード',

  app_debuginfo: 'デバッグ情報',
  app_adbstatus: 'ADB状態',
  app_on1: '開く',
  app_off1: 'オフ',
  app_devicemode: 'デバイスモード',
  app_normalmode: 'ノーマルモード',
  app_debugmode: 'デバッグモード',
  app_signstatus: '検札の状態',
  app_catchlog: 'ログをキャプチャ',
  app_tobenimportdv: 'デバイスをインポートします',
  app_lineimporttip: '設備の種類、メーカー、型番、住所など基礎データを設定してください',
  app_cannotwithsysapp: 'システムアプリケーションが含まれていません。',
  app_locktime: 'ロック時間',

  app_risksetting: 'ファン設定',
  app_lockinfo: 'ロック情報',

  app_riskdetail: 'アラーム詳細',
  app_lockcity: '都市をロックする',
  app_locklngandlat: '都市をロックする',
  app_lockstate: '都市をロックする',
  app_bindenclosure: '都市をロックする',
  app_unbindenclosure: '経緯度をロックする',
  app_sureunlock: 'ロック解除確認',

  app_plsinputimgfile: '请上传img格式文件',
  app_animatefile: 'アニメーションファイル',

  app_bglock: 'バックグラウンドロック',
  app_request: '申し込み済み',
  app_unrequest: '未申請',

  app_lockdevice: 'デバイスをロック',
  app_pusheddvlist: 'アプリケーションをアンマウント',
  app_appuninstall: 'アプリケーションをアンマウント',

  app_unlocked: 'ロック解除済み',
  app_unlockdevice: 'ロック解除装置',

  app_pushnumcantfive: '推送数量は5つを超えてはならない',
  app_selectedappshoupass: 'プッシュ数量は5個を超えてはいけません。',

  app_adRefreshfreq: '広告更新頻度',


  app_uninsfail: 'アンマウントに失敗しました',
  app_uninssc: 'アンマウント成功',
  app_preversion: '基本バージョン',

  app_addstfile: 'プロファイルを追加',
  app_filetag: 'ファイルの識別',

  app_filestss: 'プロファイル',
  app_uploadfilest: 'プロファイルをアップロード',
  app_excludeapp: '適用を除外',
  app_reupload: 'アップロード',
  app_excludefsttip: 'アプリケーションを排除するためにアプリケーション名が入力され、この構成は、デフォルトではファイル識別子をサポートするすべてのアプリケーションで使用される',

  app_limitxml: 'xml文件のみ',
  app_configfile: '設定ファイル',

  app_udversion: 'バージョンを更新',

  app_udsamexml: '同じタグのxmlしか更新できない',
  app_udxmllowertip: '更新されたバージョンは、現在のバージョンよりも低く、履歴に現れ、リストには表示されません',

  app_childacmg: 'サブアカウント管理',

  app_unldvwftip: '当設備は【{wl}】をバインディングしているが,バインディングを同時に削除しますか',

  app_udmode: '更新モード',

  app_append: '追加',


  /*** 非智能设备管理 */
  app_importapp: 'アプリケーションをインポート',
  app_adddate: '日付を追加',
  app_addtask: 'タスクを追加',
  app_addtesttask: 'タスクテストを追加',
  app_appdesc: 'アプリケーションの説明',
  app_srcdesc: 'リソースの説明',
  app_downapp: 'アプリケーションをダウンロード',
  app_downfile: 'ファイルをダウンロード',
  app_addsrc: 'リソースを追加',
  app_importsrc: 'リソースをインポート',
  app_srcname: 'リソース名',
  app_srcver: 'リソースバージョン',
  app_downsrc: 'リソースをダウンロード',
  app_number: '番号付け',
  app_softinfo: 'ソフトウェア情報',
  app_allstatus: 'すべての状態',
  app_mstype14: 'スキャンガンアプリ',
  app_mstype15: 'スキャンガン資源ファイル',
  /*** end */

  app_filedesc: 'ファイルの説明',
  app_filetype: 'ファイルタイプ',
  app_subtype: 'サブタイプ',
  app_addfile: 'ファイルを追加',
  app_stmgpsw: 'パスワードの設定を管理する',
  app_mapsl: '地図の選択',
  app_bdmap: 'Baiduの地図',
  app_map: '地図',
  app_right: 'パーミッション',
  app_addconfig: '設定を追加',
  app_editconfig: '設定を編集',
  app_mgpsw: 'パスワードの管理',
  app_dvconfiglist: 'デバイスリストの設定',
  app_appconfigst: 'アプリケーションの設定',
  app_applytime: 'アプリケーション時間',
  app_secrname: '鍵の名前',
  app_secrdesc: '鍵の説明',
  app_addsecrrule: '鍵ルールを追加',
  app_editsecrrule: '鍵ルールを編集',
  app_secrdvlist: '鍵デバイスリスト',
  app_secrupdatest: '鍵の更新状態',
  app_waitupdate: '更新待ち',


  app_addrandport: 'アドレスとポート',
  app_filepath: 'ファイルパス',
  app_queryudfre: '更新頻度の照会',
  app_lcupload: 'ローカルアップロード',
  app_hour: '時間',
  app_addofcloud: 'クラウド追加',
  app_bglist: 'バックグラウンドリスト',
  app_cntype: '接続モード',
  app_codegunsrc: 'スキャンガン資源',

  // un process
  app_partpkg: 'インクリメンタルパッケージ',
  app_codegunapp: 'スキャンガンの応用',
  app_starttime: '開始時間',

  app_oilmcsrc: '給油機の資源',

  app_downtpl: 'テンプレートをダウンロード',

  app_plsstype: 'サブタイプを選択してください',

  app_allstyps: 'すべてのサブタイプ',

  app_ftooltip: 'アニメーション/ロゴファイルのオンライン作成ツール',

  app_appendpush: '追加プッシュ',

  app_ipitonlylgchar: '入力項目は英数字と下線などの合法的な文字しかできません。',

  app_enable: '有効にする',

  app_spfileis: 'ファイルサポートフォーマットは',

  app_cnsetting: '接続の設定',

  app_newtask: '新しいタスク',
  app_adddv: 'デバイスを追加',
  app_fileinsst: 'ファイルの設定',
  app_insscautoop: '自動でインストールできました。',
  app_pushsctipins: 'プッシュ成功ヒントインストール',
  app_total: '合計',
  app_wait: '待つ',
  app_pushing: '配達中',
  app_pushsldev: '選択されたデバイスをプッシュします',
  app_repushdv: '再押し失敗デバイス',
  app_outputdv: 'エクスポートデバイス',
  app_udtime: '更新日時',
  app_surepsxdv: '{num}台の機器をプッシュすることを確定',

  app_apppush: 'アプリケーション',
  app_fmwpush: 'ファームウェアプッシュ',
  app_advpush: '広告送り',
  app_onampush: '起動動画の転送',
  app_offampush: 'シャットダウン動画の送信',
  app_onoffampush: 'スイッチマシン動画プッシュ',
  app_onlgpush: '开机logo推送',
  app_wppush: '壁紙プッシュ',
  app_stfpush: '設定ファイル転送',
  app_codemc: '掃引機',
  app_codemcsrc: 'スイープリソース',
  app_sysud: 'システムの更新',
  app_fmwud: 'ファームウェア更新',
  app_anmud: 'アニメーションの更新',
  app_qcgunsrcps: 'スキャンガン資源プッシュ送',
  app_iscltask: 'スキャンガン資源プッシュ送',
  app_resrc: 'リソース',
  app_srcfileps: 'リソースファイル転送',

  app_helptip: 'リマインダのヘルプ',
  app_newpsetnewver: '新しいTMS改訂入口',
  app_newptdetail: '	機能を押してバージョンを変更した後、ユーザーはプッシュしてタスクページ（タスク管理→転送タスク）を開いて、新しいタスクをクリックして、新しいタスクページに入り、タスク名を入力し、必要なファイルを選んで、新しいプッシュジョブを作成します',
  app_newptdetail1: '	タスクの新規作成が完了したら、自動的にタスクの詳細ポップアップデバイスの選択にジャンプします。ユーザは大量にプッシュまたは単一のデバイスをプッシュして転送できます。タスクの詳細において、ユーザは何度もデバイスを追加できます',


  app_daterange: '日付範囲',
  app_olinepday: '毎日オンライン数量',
  app_onlineavgt: '平均オンライン時間',
  app_devicewhe: 'デバイス分布',
  app_statistic: '統計',
  app_today: '今日',
  app_thisweek: '今週',
  app_thismonth: '今月',

  app_addblfile: 'ブラックリストファイルを追加',
  app_blacklsname: 'ブラックリスト名',
  app_editblls: 'ブラックリストを編集',
  app_blsdesc: 'ブラックリストの説明',
  app_blsdvlist: 'ブラックリストのデバイスリスト',

  app_wldesc: 'ブラックリストのデバイスリスト',
  app_filectncr: 'ブラックリストのデバイスリスト',

  app_khour: '時刻',
  app_kday: '日',
  app_yesterday: '昨日',
  app_rc15d: '近15日',
  app_rc30d: '近30日',
  app_stinfo: '状態情報',

  app_croln: '現在のオンライン',
  app_crslp: '現在のスリープ',
  app_croff: '現在オフライン',
  app_lstol: '最後のオンライン時間',
  app_lstsl: '最後のスリープ時間',
  app_lstof: '最後のオフライン時間',
  app_limitiplg: '限制IP段登录',
  app_allowiplg: '允许IP段登录',
  app_illegal: '非合法',
  app_limitiptip: '制限する必要があるIPセグメントを入力してください。入力しない場合、制限されません',
  app_allowiptip: '許可されたIPセグメントを入力してください。すべてのIPアクセスを許可するために入力しないでください',
  app_unknow: '不明',
  app_hisstatus: '履歴の状態',
  app_active1: '活躍する',
  app_unuse: '有効化されていません',
  app_addpsg: 'チャンネルを追加',
  app_psgname: 'チャンネル名',
  app_authstat: '認証の状態',
  app_cbackad: 'コールバックアドレス',
  app_bsrqsadwl: '業務請求住所名簿',
  app_appwtls: 'ホワイトリストを使う',
  app_addapppgkn: 'アプリケーションの名前を追加',
  app_authopen: 'オープンを許可する',
  app_authclose: '許可を無効にする',
  app_addaddr: 'アドレスを追加',
  app_developer: '開発者',
  app_editpasg: 'チャンネルを編集',
  app_usertype: 'ユーザータイプ',
  app_generate: '生成',
  app_gentip: 'AppSecretを新たに生成すると,既存のAppSecretは無効となり,オープンプラットフォームへのアクセスが継続できなくなる。AppSecretを再生成しますか',
  app_open1: '開く',
  app_hide: '非表示',

  app_subtask: 'サブタスク',
  app_sltstype: 'タスクの種類を選択',
  app_command: 'コマンド',
  app_addsubts: 'サブタスクを追加',
  app_commtype: 'コマンドの種類',
  app_taskpros: 'タスクの進捗',
  app_cursubts: '現在のサブタスク',
  app_commpush: '指令送り',
  app_dvrestart: 'デバイスの再起動',
  app_recvorgst: '出荷時設定を復元',
  app_recvanimt: 'アニメーションを復元',
  app_dvlock: '設備ロック機',
  app_dvunlock: '設備のロック解除',
  app_inbdside: 'もう境界に着きました',
  app_subtsnum: 'サブタスクの数',
  app_tscrtime: 'サブタスクの数',
  app_pushfile: 'ファイルを送る',
  app_dvcomm: 'デバイス命令',
  app_ing: '進行中',

  app_core: 'カーネル',
  app_filesys: 'ファイルシステム',
  app_commd1fw: '通讯模块1固件',
  app_commd2fw: '通讯模块2固件',
  app_readcfw: 'カードリーダーファームウェア',
  app_pswkbfw: 'パスワードキーボードファームウェア',
  app_scanhfw: 'スキャンヘッドファームウェア',
  app_actpossp: '激活POS通话',
  app_natpossp: '关闭POS通话',
  app_setcallf: '通話機能の設定',
  app_clupappdt: '通話機能の設定',
  app_isclupappdt: 'アプリケーションデータのクリアを決定します。',
  app_impdistbt: '導入ルート業者',
  app_impmctip: 'アップロード待ちのファイルは、エクセルのみで10 mを超えません。',
  app_callfunc: '通話機能',

  app_protocal: 'プロトコル',
  app_prtsltip: 'HTTPSを選択するときは、このプロトコルはインターフェースがサポートされていることを保証しなければなりません。',
  app_rgsvpm: 'ライセンスサービスのパラメータ',
  app_rgsvip: 'ライセンスサービスIP',
  app_bgntpm: 'バックグラウンド通知パラメータ',
  app_bgntip: 'バックエンド通知IP',
  app_port: 'ポート',
  app_flexist: 'ファイルは既に存在します',
  app_delcer: '証明書を削除',
  app_cerid: '証明書の指紋',
  app_wallpaper: '壁紙',

  app_forceins: '強制インストール',
  app_autorun: 'インストール後自動運転',

  app_cusins: '客制の取り付け',
  app_cusuins: 'アンマウント',
  app_forcerun: '強制執行',
  app_pushtest: 'プッシュテスト',
  app_pltfblt: 'プラットフォームのお知らせ',

  app_addblt: '公告を追加',
  app_blttt: '公告の概要',
  app_readnum: '読書回数',
  app_bltct: '公告の内容',
  app_pltudrd: 'プラットフォームが更新されました',
  app_udlog: 'ログを更新',
  app_addver: 'バージョンを追加',
  app_pubdate: '公開日',
  app_updct: '内容を更新する',
  app_editblt: '公告を編集する',
  app_editver: 'バージョンを編集',
  app_verupdate: 'バージョンの更新',
  app_clviewdt: 'クリックして詳細を表示します',
  app_viewmore: 'もっと見る',
  app_comptime: 'コンパイル時間',
  app_insafnorun: 'インストール後は自動運転ではありません。',
  app_normalins: '普通セットアップ',
  app_normalunins: '一般アンマウント',
  appp_tipoperate: 'ヒント操作',
  app_onlyprov: '省のみを選択',
  app_filepush: 'ファイル転送',
  app_region: 'エリア',
  app_srcmechan: 'キーワード検索チャネルを入力',
  app_ckcode: '認証コード',
  app_cantuins: 'アンインストール不可',
  app_ippkgname: 'パッケージ名を入力',
  app_onlypicfm: '(JPG,PNG,GIF...)のみアップロードできます',
  app_fludlist: 'ファイル更新リスト',
  app_param: 'パラメータ',
  app_catching: 'キャプチャ中',
  app_ulding: 'アップロード中',
  app_ulyet: 'アップロード完了',
  app_endcatch: 'スナップショットを終了します',
  app_iscatch: 'キャプチャーを始めますか',
  app_opterinfo: 'ターミナル情報をエクスポート',
  app_bcopterinfo: '一括エクスポート情報',
  app_cpttime: '切り取り時間',
  app_eqcapture: 'デバイススクリーンショット',
  app_scapture: 'スクリーンショット',
  app_surestcap: 'スクリーンショットを確定しますか',
  aap_lokscrn: '鎖屏',
  app_ulkscrn: '解屏',
  app_appautrn: 'App自己起動',
  app_perms: '単位:ミリ秒',
  app_wattime: '待ち時間',
  app_lcswitch: 'launcher切り替え',
}


export default zh_cn;
